<style scoped lang="scss">
    .c-el-input-small {
        width: 120px;
    }
    .c-el-input-middle {
        width: 162px;
    }
</style>

<template>
  <div class="page-employee-batteryData">
    <el-alert class="mrgb10" type="warning" :closable="false">
        <span slot="title">
            当前为员工管理的换电记录，默认显示员工<span class="col_danger fwb">【所有工作过的服务区】</span>的数据。
        </span>
    </el-alert>
    <div class="toolbars mrgb5">
        <div class="buttons mrgb5">
            <div class="fl">
                <!-- <el-button class="mrgr5 mrgb5" type="danger" size="medium" v-if="isOperationBatteryChangeTaskAudit"
                    @click="batchAudit()">批量审核</el-button> -->
                <el-button-group class="mrgr5 mrgb5">
                    <el-button :class="$root.isPc ? '' : 'mobile-group-button'" type="primary" v-for="(tab, index) in tabs" :plain="tabIndex !== index"
                        :key="'employee_tab_' + index" size="medium" @click="tabClick(index)">{{ tab }}</el-button>
                </el-button-group>
                <el-date-picker class="c-datetime-range mrgr5 mrgb5" v-model="selectedTime" type="datetimerange" size="medium" v-show="isShowSelectTime"
                    :picker-options="pickerOptions" :default-time="['00:00:00', '23:59:59']" @change="_search"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    align="right">
                </el-date-picker>
            </div>
            <div class="fr">
                <!--服务区选择-->
                <service-area class="mrgr5 mrgb5" :size="'medium'" v-if="isDetailQuery"
                    :options="serviceAreas" 
                    :isCurrentArea="listQuery.isFilterArea"
                    :isReset="isResetSelectArea"
                    @change="serviceAreaChange"></service-area>
                <span class="mrgr5 mrgb5" v-else>
                    <el-checkbox v-model="listQuery.isFilterArea" label="仅看当前服务区" border size="medium"
                        @change="serviceAreaChange"></el-checkbox>
                </span>
                <el-select class="c-el-input c-el-input-small mrgr5 mrgb5" placeholder="审核状态" size="medium" filterable
                    clearable v-model="listQuery.auditState" @change="_search()">
                    <el-option v-for="t in taskAuditFlags" :key="t.value" :label="t.text" :value="t.value"></el-option>
                </el-select>
                <el-select class="c-el-input c-el-input-small mrgr5 mrgb5" placeholder="绩效类型" size="medium" filterable
                    clearable v-model="listQuery.flag" @change="_search()">
                    <el-option v-for="t in arrMoveTaskFlag" :key="t.value" :label="t.desc" :value="t.value"></el-option>
                </el-select>
                <el-input class="c-el-input c-el-input-middle mrgr5 mrgb5" placeholder="员工的姓名/手机号" clearable v-model="listQuery.telOrName"
                    size="medium" v-if="!isDetailQuery"></el-input>
                <el-input class="c-el-input c-el-input-small mrgr5 mrgb5" placeholder="车辆ID" clearable v-model="listQuery.keywords"
                    size="medium"></el-input>
                <el-button type="primary" size="medium" @click="_search()"><i class="fa fa-search"></i> 查询</el-button>
                <el-dropdown trigger="click">
                    <el-button class="mrgl5 mrgr5 mrgb5" type="warning" size="medium">
                        <i class="fa fa-sign-out"></i> 导出<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="openExportExcel()">导出换电记录</el-dropdown-item>
                        <el-dropdown-item @click.native="openExportAuditExcel()">导出审核记录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <!-- <el-tooltip class="item" effect="dark" content="变更换电规则后，换电记录将更新同步更新。" placement="bottom-end">
                    <el-button type="danger" size="medium" @click="_handle()"><i class="fa fa-refresh"></i> 变更换电规则</el-button>
                </el-tooltip> -->
            </div>
            <div class="clearb"></div>
        </div>
    </div>
    <div class="mrgb10">
        <el-tag type="primary" size="medium" class="mrgr10">换电量：{{ countItem.totalCount }}</el-tag>
        <el-tag type="danger" size="medium">有效换电量：{{ countItem.effectiveCount }}</el-tag>
    </div>
    <el-table :data="tableData" style="width: 100%" border size="medium" @sort-change="sortChange" @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" width="40" fixed="left"></el-table-column> -->
        <el-table-column label="换电人姓名" prop="op_man" width="100"></el-table-column>
        <el-table-column label="联系电话" prop="phone" width="150"></el-table-column>
        <el-table-column label="所属平台" prop="platform" width="100"></el-table-column>
        <el-table-column label="服务区" prop="serviceName" width="120"></el-table-column>
        <el-table-column label="车辆号" prop="car_id" width="120"></el-table-column>
        <el-table-column label="开仓时间" prop="open_bat_box_time" :formatter="tableDateFormat" sortable="custom" width="160"></el-table-column>
        <el-table-column label="关仓时间" prop="close_bat_box_time" :formatter="tableDateFormat" sortable="custom" width="160"></el-table-column>
        <el-table-column label="换电持续时间" prop="last_time_str" width="120"></el-table-column>
        <el-table-column label="换电前电量" prop="rest_battery_before" width="120" sortable="custom"></el-table-column>
        <el-table-column label="换电后电量" prop="rest_battery_after" width="120" sortable="custom"></el-table-column>
        <el-table-column label="开始换电站点" prop="start_park_name" width="200"></el-table-column>
        <el-table-column label="结束换电站点" prop="end_park_name" width="200"></el-table-column>
        <el-table-column label="小安系统绩效" prop="performance"></el-table-column>
        <el-table-column label="是否有效" prop="flag" width="100" fixed="right">
            <template slot-scope="scope">
                <el-tooltip placement="left-start" :disabled="!scope.row.handleConfig ? true : false">
                    <div slot="content" v-if="scope.row.handleConfig">
                        <div class="mrgb5">换电规则：</div>
                        <div class="mrgb2" v-if="scope.row.handleConfig.beforeMaxPower !== null">
                            换电前最大电量：{{ scope.row.handleConfig.beforeMaxPower }}%
                        </div>
                        <div class="mrgb2" v-if="scope.row.handleConfig.afterMinPower !== null">
                            换电后最低电量：{{ scope.row.handleConfig.afterMinPower }}%
                        </div>
                        <div class="mrgb2" v-if="scope.row.handleConfig.powerDiff !== null">
                            换电前后电量差：{{ scope.row.handleConfig.powerDiff }}%
                        </div>
                        <div class="col_warning mrgt5" v-if="scope.row.auditFlag !== null">当前有修改，可点击查看</div>
                    </div>
                    <span @click="openAuditLogs(scope.row)">
                        <el-tag type="danger" size="small" v-if="scope.row.flag == 0">{{ scope.row.flag }}</el-tag>
                        <el-tag type="success" size="small" v-else-if="scope.row.flag == 1">{{ scope.row.flag }}</el-tag>
                        <el-tag type="primary" size="small" v-else>{{ scope.row.flag }}</el-tag>
                    </span>
                </el-tooltip>
                <!-- <el-button style="padding: 5px 8px;" class="mrgl5" size="mini" v-if="isOperationMoveTaskAudit"
                    @click="batchAudit(scope.row)">修改</el-button> -->
            </template>
        </el-table-column>
    </el-table>

    <div class="pagination-container" v-if="isPagination">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" 
            :current-page="listQuery.page" :page-sizes="appPageSizes" :page-size="listQuery.size" 
            layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </div>

    <!--审核-->
    <audit :ref="refAudit" @refreshData="getDataList()"></audit>
    <!--审核日志-->
    <audit-logs :ref="refAuditLogs"></audit-logs>
    <!--更新换电数据的规则-->
    <battery-condition :ref="refBatteryCondition" @refreshData="_search()"></battery-condition>
  </div>
</template>

<script>
  import permission from "@/mixins/permission"
  import enumConfigs from "@/mixins/enumConfigs"
  import configMixins from "@/mixins/config"
  import * as funMaintenance from '@/api/maintenance'
  import * as funEmployees from '@/api/employees'
  import { AnalysisBatteryTask } from "@/mixins/commonPageExport"
  import moment from "moment"
  import audit from "@/views/admin/maintenance/components/batteryAudit"
  import AuditLogs from "@/views/admin/maintenance/components/auditLogs"
  import BatteryCondition from "@/views/admin/maintenance/components/batteryCondition"
  import ServiceArea from "@/components/Platform/ServiceArea"
  export default {
    name: "pageEmployeeBatteryData",
    mixins: [permission, enumConfigs, configMixins],
    components: { audit, AuditLogs, BatteryCondition, ServiceArea },
    data() {
      let that = this
      return {
        refAudit: "refBatteryDataAudit",
        refAuditLogs: "refBatteryDataAuditLogs",
        refBatteryCondition: "refBatteryDataToCondition",
        tableData: [],
        total: null,
        defaultQueryParams: {
            platform: "",
            area: "",
            flag: null,
            auditState: null, // 审核状态统一获取，然后转换为下面两个值
            isAudited: null,
            auditFlag: null,
            keywords: "",
            beginDate: "",
            endDate: "",
            page: 1,
            size: window.$common.appPageSize,
            sorting: "",
            isFilterArea: false // 添加仅看当前服务区标志
        },
        listQuery: {},
        isPagination: false,
        selectedTime: [moment().startOf("month").format("YYYY-MM-DD 00:00:00"), moment().format("YYYY-MM-DD 23:59:59")],
        pickerOptions: {
            shortcuts: [
                {
                    text: "昨天",
                    onClick: (picker) => {
                        let timeArr = that.setPickerTime(picker, 1, "days")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近一周",
                    onClick: (picker) => {
                        let timeArr = that.setPickerTime(picker, 1, "weeks")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近一月",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 1, "months")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近三月",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 3, "months")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近半年",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 6, "months")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近一年",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 1, "years")
                        that.setQueryTime(timeArr)
                    }
                }
            ]
        },
        tabIndex: 0,
        tabs: ["昨日", "本月", "上月", "自定义"],
        isShowSelectTime: false,
        batchSelections: [],
        isDetailQuery: false,
        serviceAreas: [],
        countItem: {
            totalCount: 0, // 维修量
            effectiveCount: 0 // 有效维修量
        },
        isResetSelectArea: false
      }
    },
    watch: {
        "$store.getters.serviceArea"(v) {
            this.mxIsSameActiveTabWithRoute(() => {
                this.serviceAreaChange(this.listQuery.isFilterArea)
            })
        }
    },
    mounted() {
        this.open()
    },
    methods: {
        open(params) {
            this.countItem = {
                totalCount: 0,
                effectiveCount: 0
            }
            this.isResetSelectArea = false
            // 重置查询参数
            this.listQuery = { ...this.defaultQueryParams }
            // 否则就是带参数查询，注意：不会有其他情况
            if (params) {
                this.isDetailQuery = true
                this.listQuery.isFilterArea = params.isFilterArea || false
                this.listQuery.platform = this.listQuery.isFilterArea ? this.$store.getters.servicePlatform : ""
                this.listQuery.area = this.listQuery.isFilterArea ? this.$store.getters.serviceArea : ""
                this.listQuery.keywords = params.keywords || ""
                this.listQuery.telOrName = params.telOrName || ""
                if (params.selectedTime && params.selectedTime.length == 2) {
                    this.selectedTime = params.selectedTime
                }
                if (params.type !== undefined) {
                    // 0：无效，1：有效
                    this.listQuery.flag = Number(params.type)
                } else {
                    this.listQuery.flag = null
                }
                if (params.tabIndex !== undefined) {
                    this.tabClick(params.tabIndex, true)
                    if (params.tabIndex == 3) {
                        this._search()
                    }
                } else {
                    this.tabClick(0)
                }
            } else {
                this.isDetailQuery = false
                setTimeout(() => {
                    if (!this.isDetailQuery) {
                        this.tabClick(0)
                    }
                }, 500);
            }
        },
        close() {
            this.isResetSelectArea = true
        },
        // 重写本页的时间范围的快捷筛选，设置时间
        setPickerTime(picker, spaceTime, dateStr, isStartOf) {
            let timeArr = []
            let startTime = null
            let endTime = moment().subtract(1, "d").format("YYYY-MM-DD 23:59:59")
            startTime = moment().subtract(spaceTime, dateStr).format("YYYY-MM-DD 00:00:00")
            startTime = moment(startTime).format("YYYY-MM-DD 00:00:00")
            timeArr = [startTime, endTime]
            if (picker) {
                picker.$emit('pick', timeArr);
            }
            return timeArr
        },
      setQueryTime(timeArr) {
          this.listQuery.beginDate = timeArr[0] || ""
          this.listQuery.endDate = timeArr[1] || ""
      },
      handleSizeChange(val) {
        window.$common.fullLoading()
        this.listQuery.size = val
        this.getDataList()
      },
      handleCurrentChange(val) {
        window.$common.fullLoading()
        this.listQuery.page = val
        this.getDataList()
      },
      setSelectedTime() {
          let psTime = ""
          let peTime = ""
          if (this.selectedTime && this.selectedTime[0] && moment(this.selectedTime[0]).isValid()) {
              psTime = moment(this.selectedTime[0]).format("YYYY-MM-DD HH:mm:ss")
          }
          if (this.selectedTime && this.selectedTime[1] && moment(this.selectedTime[1]).isValid()) {
              peTime = moment(this.selectedTime[1]).format("YYYY-MM-DD HH:mm:ss")
          }
          this.listQuery.beginDate = psTime
          this.listQuery.endDate = peTime
          this.selectedTime = [this.listQuery.beginDate, this.listQuery.endDate]
      },
      tranceAuditState() {
        let state = this.listQuery.auditState
        if (typeof state === "boolean") {
          this.listQuery.isAudited = state
          this.listQuery.auditFlag = null
        } else if (typeof state === "number") {
            this.listQuery.isAudited = null
            this.listQuery.auditFlag = state
        } else {
            this.listQuery.isAudited = null
            this.listQuery.auditFlag = null
        }
      },
      getDataList () {
        this.setSelectedTime()
        // 转换审核状态
        this.tranceAuditState()
        window.$common.fullLoading()
        funEmployees.GetEmployeeBatteryTasks(this.listQuery).then(response => {
            window.$common.closeFullLoading()
            this.total = response.totalCount
            this.isPagination = response.totalCount > 0 || false
            if (response && response.items && response.items.length > 0) {
                this.tableData = response.items
            } else {
                this.tableData = []
            }
            // 没有服务区，可能会获取所有的换电记录
            // 此时换电量为总定位条数，有效换电量多个服务区的有效总和
            let item = this.serviceAreas.find(x => x.areaInfo.name == this.listQuery.area)
            if (item) {
                this.countItem.totalCount = item.totalCount || 0
                this.countItem.effectiveCount = item.effectiveCount || 0
            } else {
                this.countItem.totalCount = this.total || 0
                this.countItem.effectiveCount = this.serviceAreas.reduce((pre, cur) => pre + (cur.effectiveCount || 0), 0)
            }
        })
      },
      getServiceAreas() {
        this.setSelectedTime()
        let params = JSON.parse(JSON.stringify(this.listQuery))
        params.platform = ""
        params.area = ""
        params.flag = null
        params.size = this.maxExportCount
        funEmployees.GetEmployeeBatteryTaskAreas(params).then(response => {
            this.serviceAreas = response || []
        })
      },
      serviceAreaChange(val) {
        if (val === true) {
            this.listQuery.platform = this.$store.getters.servicePlatform || ""
            this.listQuery.area = this.$store.getters.serviceArea || ""
        } else if (val && typeof val === "object" && val.length > 1) {
            this.listQuery.platform = val[0] || ""
            this.listQuery.area = val[1] || ""
        } else {
            this.listQuery.platform = ""
            this.listQuery.area = ""
        }
        this._search()
      },
      // 打开审核日志
      openAuditLogs(row) {
        // 没有审核过的，不打开审核日志
        if (row.auditFlag === null) {
            this.infoMsg("该任务还未审核过，无审核日志！")
            return false
        }
        this.$refs[this.refAuditLogs].open(row, 2)
      },
      tabClick(index, isKeepSelectTime) {
        this.tabIndex = index
        switch(index) {
          case 0: {
            let endTime = moment().subtract(1, "d").format("YYYY-MM-DD 23:59:59")
            this.selectedTime = [moment(endTime).format("YYYY-MM-DD 00:00:00"), endTime]
            break
          }
          case 1: {
            this.selectedTime = [moment().startOf("month").format("YYYY-MM-DD 00:00:00"), moment().format("YYYY-MM-DD 23:59:59")]
            break
          }
          case 2: {
            this.selectedTime = [moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD 00:00:00"), moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD 23:59:59")]
            break
          }
        }
        // 仅在查看详情进入时，改变时间更新服务区列表 (暂时只有详情进入)
        // 正常打开界面的，不更新服务区列表
        if (this.isDetailQuery) {
            this.getServiceAreas()
        }
        if (index !== 3) {
          this.isShowSelectTime = false
          this._search()
        } else {
          if (!isKeepSelectTime) {
            this.selectedTime = []
          }
          this.isShowSelectTime = true
          this.tableData = []
        }
      },
      _search() {
        this.listQuery.page = 1
        this.getDataList()
      },
      _handle() {
        this.$refs[this.refBatteryCondition].open({
            platform: this.$store.getters.servicePlatform,
            area: this.$store.getters.serviceArea,
            beginDate: this.listQuery.beginDate,
            endDate: this.listQuery.endDate,
            keywords: this.listQuery.keywords
        })
      },
      async sortChange(e) {
        console.log(e)
        let params = ["open_bat_box_time", "close_bat_box_time", "rest_battery_before", "rest_battery_after"]
        if (e.order) {
            this.listQuery.sorting = `${e.prop} ${e.order}`
        } else {
            this.listQuery.sorting = ""
        }
        this._search()
      },
      handleSelectionChange(val) {
        this.batchSelections = val
      },
      batchAudit(row) {
        let ids = row && row.id ? [row.id] : this.batchSelections.map(x => x.id)
        if (ids.length > 0) {
            this.$refs[this.refAudit].open(ids, row)
        } else {
            this.warningMsg("请先勾选审核数据!")
            return false
        }
      },
      // 导出excel
      openExportExcel() {
        if (this.total > this.maxExportCount) {
            this.warningMsg("不允许导出超过2万条数据，如有需要，请联系管理员处理!")
            return false
        }
        let searchs = JSON.parse(JSON.stringify(this.listQuery))
        searchs.page = 1
        searchs.size = this.maxExportCount
        window.$common.fullLoading()
        funEmployees.GetEmployeeBatteryTasks(searchs).then(res => {
            if (res && res.items && res.items.length > 0) {
                let tableDatas = res.items.map(x => {
                    x.open_bat_box_time = this.getFormatDate(x.open_bat_box_time)
                    x.close_bat_box_time = this.getFormatDate(x.close_bat_box_time)
                    return x
                })
                let exportData = ""
                if (searchs.beginDate && searchs.endDate) {
                    let sbtd = moment(searchs.beginDate).format("YYYY-MM-DD")
                    let ebtd = moment(searchs.endDate).format("YYYY-MM-DD")
                    exportData = sbtd == ebtd ? sbtd : `${sbtd}至${ebtd}`
                } else {
                    exportData = "全部"
                }
                let exportName = `${this.listQuery.area || ""}员工换电数据(${exportData}).xlsx`
                AnalysisBatteryTask(exportName, tableDatas)
            } else {
                window.$common.closeFullLoading()
                setTimeout(() => {
                    this.alert("没有需要导出的数据!")
                }, 10)
            }
        }).catch(() => {
            console.log("export error")
        })
      },
      openExportAuditExcel() {
            if (this.total > this.maxExportCount) {
                this.warningMsg("不允许导出超过2万条数据，如有需要，请联系管理员处理!")
                return false
            }
            let searchs = JSON.parse(JSON.stringify(this.listQuery))
            searchs.page = 1
            searchs.size = this.maxExportCount
            // 先选择审核状态才查询
            if (typeof (searchs.auditState) != "number" && typeof (searchs.auditState) != "boolean") {
                this.warningMsg("请选择审核状态!")
                return false
            }
            window.$common.fullLoading()
            funEmployees.GetEmployeeBatteryTasks(searchs).then(res => {
                if (res && res.items && res.items.length > 0) {
                    let tableDatas = []
                    res.items.forEach(x => {
                        x.open_bat_box_time = this.getFormatDate(x.open_bat_box_time)
                        x.close_bat_box_time = this.getFormatDate(x.close_bat_box_time)
                        // 审核记录倒序
                        x.auditItems.reverse()
                        x.auditItems.forEach(item => {
                            let temp = {
                                ...x,
                                auditStatus: item.isEffective ? "有效" : "无效",
                                auditOperator: item.operator,
                                auditTime: this.getFormatDate(item.creationTime),
                                auditRemark: item.remark
                            }
                            tableDatas.push(temp)
                        })
                    })
                    let exportData = ""
                    if (searchs.beginDate && searchs.endDate) {
                        let sbtd = moment(searchs.beginDate).format("YYYY-MM-DD")
                        let ebtd = moment(searchs.endDate).format("YYYY-MM-DD")
                        exportData = sbtd == ebtd ? sbtd : `${sbtd}至${ebtd}`
                    } else {
                        exportData = "全部"
                    }
                    let exportName = `${this.listQuery.area || ""}员工换电审核日志(${exportData}).xlsx`
                    AnalysisBatteryTask(exportName, tableDatas, true)
                } else {
                    window.$common.closeFullLoading()
                    setTimeout(() => {
                        this.alert("没有需要导出的数据!")
                    }, 10)
                }
            }).catch((ex) => {
                console.log("export error: ", ex)
            })
        }
    }
  }
</script>